import { IncomingMessage } from 'http';

import { getUserCookieConfig } from './user/getUserCookieConfig';
import { CookieConfig } from './cookieHelpers';

export function getCookieConfigs(req: IncomingMessage) {
  const { userCookieConfig, userOldCookieConfig } = getUserCookieConfig(req);
  const cookieConfigs: CookieConfig[] = [userCookieConfig, userOldCookieConfig];

  return cookieConfigs;
}
